import { Tab, Tabs, useTheme } from "@mui/material";

export default function NewPopupTabs({
    tabs,
    selectedIndex,
    handleTabChange,
}: {
    tabs: {
        label: string,
        index: number,
    }[],
    selectedIndex: number,
    handleTabChange: (event: React.SyntheticEvent, index: number) => void,
}) {
    const theme = useTheme();

    return (
        <div className="w-full border-b border-light-outline">
            <Tabs 
                value={selectedIndex} 
                onChange={handleTabChange}
                sx={{
                    minHeight: 0,

                    '& .MuiTabs-indicator': {
                        backgroundColor: theme.palette.primary.main,
                    }
                }}
            >
                {tabs.length > 0 && tabs.map((tab,i) => (
                    <Tab 
                        key={i}
                        label={tab.label}
                        value={tab.index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignContent: 'center',
                            gap: '2px',
                            lineHeight: 1,
                            fontSize: '12px',
                            fontFamily: 'Montserrat',
                            minHeight: 0,
                            padding: '12px 16px',

                            '&.Mui-selected': {
                                color: theme.palette.primary.main,
                            }
                        }}
                    />
                ))}
            </Tabs>
       </div>
    )
}